const PATH_URL = [
  { path: '/', color: 'text-green' },
  { path: '/courses', color: 'text-green' },
  { path: '/reservations', color: 'text-green' },
  { path: '/reservation/new', color: 'text-white' },
  { path: '/auth/login', color: 'text-white' },
  { path: '/signup', color: 'text-white' },
  { path: '/course/new', color: 'text-white' },
  { path: '/courses/delete', color: 'text-green' },
  { path: '/courses/delete', color: 'text-green' },
];

export default PATH_URL;
